import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel} from "../shared";
import {UserCatalogLinkResponse} from "../../../../../models/aggregates/catalog/user-catalog-link-response.model";
import {Observable} from "rxjs";

// core2/platform/dm/catalog-login-subject-links/{tenantCode}/login-tenant-ep

@Injectable({providedIn: 'root'})
export class CatalogLoginSubjectLinkTenantEpService extends BaseApiTemplateService<any> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links';
    this.httpClient = http;
  }

  getAllTenantEp(tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  getByGuidTenantEp(tenantCode: string, guid:string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaTenantEp(
    tenantCode: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  postByTenantEp(tenantCode: string, dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  putByTenantEp(tenantCode: string, dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }



  deleteByTenantEp(tenantCode: string,  guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/' + tenantCode + '/login-tenant-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  // /core2/platform/dm/catalog-login-subject-links/multiple-delete/{tenantCode}/tenant-admin-ep
  deleteMultipleByTenantEp(
    dto: any,
    tenantCode: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const endpointPath = `${Core2Config.PLATFORM_URL_PREFIX}${Core2Config.DOMAIN_PREFIX}catalog-login-subject-links/multiple-delete/${tenantCode}/tenant-admin-ep`;
    const apiUrl = visa.api_domain_url + endpointPath;

    return this.httpClient.post<ApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

  // core2/platform/dm/catalog-login-subject-links/custom/{tenantHdrGuid}/tenant-admin-ep/query?

  getByCriteriaTenantCustomEp(
    tenantGuid: string,
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'catalog-login-subject-links/custom/' + tenantGuid + '/tenant-admin-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  // /multiple-install/{tenantCode}/tenant-admin-ep
  installMultipleByTenantAdminEp(
    dto: any,
    tenantCode: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    const endpointPath = `${Core2Config.PLATFORM_URL_PREFIX}${Core2Config.DOMAIN_PREFIX}catalog-login-subject-links/multiple-install/${tenantCode}/tenant-admin-ep`;
    const apiUrl = visa.api_domain_url + endpointPath;

    return this.httpClient.post<ApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

}
